import React, { Component } from 'react';

import CircularProgress from 'material-ui/CircularProgress';

import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4lang_es_ES from '@amcharts/amcharts4/lang/es_ES';

export class Temp extends Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: false
        };
    };

    componentDidMount() {
        setTimeout(() => {
            this.loadChart();
        }, 1000);
    }

    loadChart = () => {
        this.setState({
            visible: true
        });

        const chart = am4core.create("modelo-temp", am4charts.XYChart);
        chart.zoomOutButton.disabled = true;
        chart.language.locale = am4lang_es_ES;

        const
            { data, buffer } = this.props,
            trendStart = data[0].hora_local,
            trendEnd    = data[data.length - 1].hora_local
        ;

        chart.data = data;

        // Set input format for the dates
        chart.dateFormatter.inputDateFormat = 'yyyy-MM-ddTHH:mm:ss';

        // Create axes
        const dateAxis = chart.xAxes.push(new am4charts.DateAxis());
        dateAxis.groupData = false;
        dateAxis.renderer.grid.template.disabled = true;
        dateAxis.baseInterval = {
            "timeUnit": "hour",
            "count": 1
        };
        dateAxis.dateFormatter.dateFormat = "dd-MM-yyyy";
        dateAxis.renderer.minGridDistance = 60;
        dateAxis.dateFormats.setKey("month", "MMM");
        dateAxis.periodChangeDateFormats.setKey("month", "[bold]MMM");
        dateAxis.dateFormats.setKey("day", "MMM dd");
        dateAxis.periodChangeDateFormats.setKey("day", "[bold]MMM");
        dateAxis.dateFormats.setKey("hour", "HH:mm");
        dateAxis.periodChangeDateFormats.setKey("hour", "[bold]MMM dd[/]");
        dateAxis.dateFormats.setKey("minute", "HH:mm");
        dateAxis.periodChangeDateFormats.setKey("minute", "[bold]MM dd[/]");

        const buttonContainer = chart.plotContainer.createChild(am4core.Container);
        buttonContainer.shouldClone = false;
        buttonContainer.align = "right";
        buttonContainer.valign = "bottom";
        buttonContainer.zIndex = 100;
        buttonContainer.marginBottom = 5;
        buttonContainer.marginRight = 5;
        buttonContainer.layout = "horizontal";
    
        const zoomOutButton = buttonContainer.createChild(am4core.Button);
        zoomOutButton.label.text = "-";
        zoomOutButton.events.on("hit", () => {
            dateAxis.zoomToIndexes(dateAxis.startIndex, dateAxis.endIndex);
        });

        // Create series
        function createAxisAndSeries(field, name, opposite, color) {
            const valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
            
            const series = chart.series.push(new am4charts.LineSeries());
            series.dataFields.valueY = field;
            series.dataFields.dateX = "hora_local";
            series.stroke = am4core.color(color);
            series.fill = am4core.color(color);
            series.strokeWidth = 2;
            series.yAxis = valueAxis;
            series.name = name;
            series.tooltipText = "[bold]{valueY}[/]";
            series.tensionX = 0.8;
            series.showOnInit = false;

            if (!!buffer.temp && buffer.temp.length > 1) {
                const rangeTemp = valueAxis.axisRanges.create();
                rangeTemp.value = buffer.temp[0];
                rangeTemp.endValue = buffer.temp[1];
                rangeTemp.axisFill.fill = am4core.color("#FF1493");
                rangeTemp.axisFill.fillOpacity = 0.2;
            } else if (!!buffer.temp && buffer.temp.length === 1) {
                const rangeTemp = valueAxis.axisRanges.create();
                rangeTemp.value = buffer.temp[0];
                rangeTemp.endValue = buffer.temp[0] + 0.2;
                rangeTemp.axisFill.fill = am4core.color("#FF1493");
                rangeTemp.axisFill.fillOpacity = 0.5;
            }

            valueAxis.min = 0;
            valueAxis.renderer.line.strokeOpacity = 1;
            valueAxis.renderer.line.strokeWidth = 2;
            valueAxis.renderer.line.stroke = series.stroke;
            valueAxis.renderer.labels.template.fill = series.stroke;
            valueAxis.renderer.opposite = opposite;
            valueAxis.cursorTooltipEnabled = false;
            valueAxis.renderer.grid.template.disabled = true;
        }

        createAxisAndSeries("temp", "Temperatura °C", false, "#FA2A5A");

        chart.cursor = new am4charts.XYCursor();
        chart.cursor.behavior = "zoomX";
        chart.cursor.xAxis = dateAxis;
        chart.cursor.lineY.disabled = true;
        chart.numberFormatter.numberFormat = "##.#";

        // Crear leyenda
        chart.legend = new am4charts.Legend();
    }

    componentWillUnmount() {
        if (this.chart) {
            this.chart.dispose();
        }
    }

    render() {
        if (this.state.visible) {
            return ( 
                <div id="modelo-temp" style={{ margin: '20px 0px' }}/>
            );
        }

        return (
            <div className="circleUPL">
                <CircularProgress color={'#db5c26'} size={186} thickness={10} value={70} />
            </div>
        )
    }
}

export class TempHum extends Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
        };
    };

    componentDidMount() {
        setTimeout(() => {
            this.loadChart();
        }, 1000);
    }

    loadChart = () => {
        this.setState({
            visible: true,
        });

        const chart = am4core.create("modelo-temp-hum", am4charts.XYChart);
        chart.zoomOutButton.disabled = true;
        chart.language.locale = am4lang_es_ES;

        const
            { data, sigatoka, buffer } = this.props,
            trendStart = data[0].hora_local,
            trendEnd = data[data.length - 1].hora_local
        ;

        chart.data = data;

        // Set input format for the dates
        chart.dateFormatter.inputDateFormat = "yyyy-MM-ddTHH:mm:ss";

        // Create axes
        const dateAxis = chart.xAxes.push(new am4charts.DateAxis());
        dateAxis.groupData = false;
        dateAxis.renderer.grid.template.disabled = true;
        dateAxis.baseInterval = {
            "timeUnit": "hour",
            "count": 1
        };
        dateAxis.dateFormatter.dateFormat = "dd-MM-yyyy";
        dateAxis.renderer.minGridDistance = 60;
        dateAxis.dateFormats.setKey("month", "MMM");
        dateAxis.periodChangeDateFormats.setKey("month", "[bold]MMM");
        dateAxis.dateFormats.setKey("day", "MMM dd");
        dateAxis.periodChangeDateFormats.setKey("day", "[bold]MMM");
        dateAxis.dateFormats.setKey("hour", "HH:mm");
        dateAxis.periodChangeDateFormats.setKey("hour", "[bold]MMM dd[/]");
        dateAxis.dateFormats.setKey("minute", "HH:mm");
        dateAxis.periodChangeDateFormats.setKey("minute", "[bold]MM dd[/]");
        // dateAxis.keepSelection = true;
        // dateAxis.start = 0.6;

        const buttonContainer = chart.plotContainer.createChild(am4core.Container);
        buttonContainer.shouldClone = false;
        buttonContainer.align = "right";
        buttonContainer.valign = "bottom";
        buttonContainer.zIndex = 100;
        buttonContainer.marginBottom = 5;
        buttonContainer.marginRight = 5;
        buttonContainer.layout = "horizontal";
    
        const zoomOutButton = buttonContainer.createChild(am4core.Button);
        zoomOutButton.label.text = "-";
        zoomOutButton.events.on("hit", () => {
            dateAxis.zoomToIndexes(dateAxis.startIndex, dateAxis.endIndex);
        });

        // Create series
        function createAxisAndSeries(field, name, opposite, color) {
            const valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
            if (chart.yAxes.indexOf(valueAxis) !== 0 ) {
                valueAxis.syncWithAxis = chart.yAxes.getIndex(0);
            }
            
            const series = chart.series.push(new am4charts.LineSeries());
            series.dataFields.valueY = field;
            series.dataFields.dateX = "hora_local";
            series.stroke = am4core.color(color);
            series.fill = am4core.color(color);
            series.strokeWidth = 2;
            series.yAxis = valueAxis;
            series.name = name;
            series.tooltipText = "[bold]{valueY}[/]";
            series.tensionX = 0.8;
            series.showOnInit = false;
            
            if (field === 'temp') {
                if (!!buffer.temp && buffer.temp.length > 1) {
                    const rangeTemp = valueAxis.axisRanges.create();
                    rangeTemp.value = buffer.temp[0];
                    rangeTemp.endValue = buffer.temp[1];
                    rangeTemp.axisFill.fill = am4core.color("#FF1493");
                    rangeTemp.axisFill.fillOpacity = 0.2;
                } else if (!!buffer.temp && buffer.temp.length === 1) {
                    const rangeTemp = valueAxis.axisRanges.create();
                    rangeTemp.value = buffer.temp[0];
                    rangeTemp.endValue = buffer.temp[0] + 0.2;
                    rangeTemp.axisFill.fill = am4core.color("#FF1493");
                    rangeTemp.axisFill.fillOpacity = 0.5;
                }
            } else if (field === 'hum') {
                if (!!buffer.hum && buffer.hum.length > 1) {
                    const rangeHum = valueAxis.axisRanges.create();
                    rangeHum.value = buffer.hum[0];
                    rangeHum.endValue = buffer.hum[1];
                    rangeHum.axisFill.fill = am4core.color("#3BC4D0");
                    rangeHum.axisFill.fillOpacity = 0.2;
                } else if (!!buffer.hum && buffer.hum.length === 1) {
                    const rangeHum = valueAxis.axisRanges.create();
                    rangeHum.value = buffer.hum[0];
                    rangeHum.endValue = buffer.hum[0] + 0.2;
                    rangeHum.axisFill.fill = am4core.color("#3BC4D0");
                    rangeHum.axisFill.fillOpacity = 0.9;
                }
            }

            if (field === "hum") {
                valueAxis.max = 100;
                
                // if (sigatoka) {
                //     const rangeHum = valueAxis.axisRanges.create();
                //     rangeHum.value = 65;
                //     rangeHum.endValue = 65.5;
                //     rangeHum.axisFill.fill = am4core.color("#3BC4D0");
                //     rangeHum.axisFill.fillOpacity = 1;
                // }
                
                const rangeHum = valueAxis.axisRanges.create();
                rangeHum.value = 65;
                rangeHum.grid.stroke = am4core.color("#3BC4D0");
            } /* else if (sigatoka) {
                const rangeTemp = valueAxis.axisRanges.create();
                rangeTemp.value = 25;
                rangeTemp.endValue = 28;
                rangeTemp.axisFill.fill = am4core.color("#FF1493");
                rangeTemp.axisFill.fillOpacity = 0.2;

                const rangeTemp1 = valueAxis.axisRanges.create();
                rangeTemp1.value = 25;
                rangeTemp1.grid.stroke = am4core.color("#FF1493");

                const rangeTemp2 = valueAxis.axisRanges.create();
                rangeTemp2.value = 28;
                rangeTemp2.grid.stroke = am4core.color("#FF1493");
            } */
            
            valueAxis.min = 0;
            valueAxis.renderer.line.strokeOpacity = 1;
            valueAxis.renderer.line.strokeWidth = 2;
            valueAxis.renderer.line.stroke = series.stroke;
            valueAxis.renderer.labels.template.fill = series.stroke;
            valueAxis.renderer.opposite = opposite;
            valueAxis.cursorTooltipEnabled = false;
            valueAxis.renderer.grid.template.disabled = true;
        }

        createAxisAndSeries("hum", "Humedad Relativa %", false, "#3BC4D0");
        createAxisAndSeries("temp", "Temperatura °C", true, "#FA2A5A");

        chart.cursor = new am4charts.XYCursor();
        chart.cursor.behavior = "zoomX";
        chart.cursor.xAxis = dateAxis;
        chart.cursor.lineY.disabled = true;
        chart.numberFormatter.numberFormat = "##.#";

        // Crear leyenda
        chart.legend = new am4charts.Legend();

        function createTrendLine(data, color) {
            const trend = chart.series.push(new am4charts.LineSeries());
            trend.dataFields.valueY = "value";
            trend.dataFields.dateX = "date";
            trend.strokeWidth = 3;
            trend.strokeDasharray = 5;
            trend.stroke = trend.fill = am4core.color(color);
            trend.strokeOpacity = 0.5;
            trend.data = data;
            trend.hiddenInLegend = false;
            trend.showOnInit = false;

            return trend;
        }
    }

    componentWillUnmount() {
        if (this.chart) {
            this.chart.dispose();
        }
    }

    render() {
        if (this.state.visible) {
            return (
                <div id="modelo-temp-hum" style={{ margin: '20px 0px' }}/>
            );
        }

        return (
            <div className="circleUPL">
                <CircularProgress color={'#db5c26'} size={186} thickness={10} value={70} />
            </div>

        )
    }
}
export class TempHumPre extends Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
        };
    };

    componentDidMount() {
        setTimeout(() => {
            this.loadChart();
        }, 1000);
    }

    loadChart = () => {
        this.setState({
            visible: true,
        });

        const chart = am4core.create("modelo-temp-hum-pre", am4charts.XYChart);
        chart.zoomOutButton.disabled = true;
        chart.language.locale = am4lang_es_ES;

        const { data, buffer } = this.props;

        chart.data = data;

        // Set input format for the dates
        chart.dateFormatter.inputDateFormat = "yyyy-MM-ddTHH:mm:ss";

        // Create axes
        const dateAxis = chart.xAxes.push(new am4charts.DateAxis());
        dateAxis.groupData = false;
        dateAxis.renderer.grid.template.disabled = true;
        dateAxis.baseInterval = {
            "timeUnit": "hour",
            "count": 1
        };
        dateAxis.dateFormatter.dateFormat = "dd-MM-yyyy";
        dateAxis.renderer.minGridDistance = 60;
        dateAxis.dateFormats.setKey("month", "MMM");
        dateAxis.periodChangeDateFormats.setKey("month", "[bold]MMM");
        dateAxis.dateFormats.setKey("day", "MMM dd");
        dateAxis.periodChangeDateFormats.setKey("day", "[bold]MMM");
        dateAxis.dateFormats.setKey("hour", "HH:mm");
        dateAxis.periodChangeDateFormats.setKey("hour", "[bold]MMM dd[/]");
        dateAxis.dateFormats.setKey("minute", "HH:mm");
        dateAxis.periodChangeDateFormats.setKey("minute", "[bold]MM dd[/]");
        // dateAxis.keepSelection = true;
        // dateAxis.start = 0.6;

        const buttonContainer = chart.plotContainer.createChild(am4core.Container);
        buttonContainer.shouldClone = false;
        buttonContainer.align = "right";
        buttonContainer.valign = "top";
        buttonContainer.zIndex = 100;
        buttonContainer.marginTop = -15;
        buttonContainer.marginRight = 5;
        buttonContainer.layout = "horizontal";
    
        const zoomOutButton = buttonContainer.createChild(am4core.Button);
        zoomOutButton.label.text = "-";
        zoomOutButton.events.on("hit", () => {
            dateAxis.zoomToIndexes(dateAxis.startIndex, dateAxis.endIndex);
        });

        // Create series
        function createAxisAndSeries(field, name, opposite, color) {
            const valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
            if (chart.yAxes.indexOf(valueAxis) !== 0 ) {
                valueAxis.syncWithAxis = chart.yAxes.getIndex(0);
            }
            
            if (field !== 'pre') {
                const series = chart.series.push(new am4charts.LineSeries());
                series.dataFields.valueY = field;
                series.dataFields.dateX = "hora_local";
                series.stroke = am4core.color(color);
                series.fill = am4core.color(color);
                series.yAxis = valueAxis;
                series.name = name;
                series.tooltipText = "[bold]{valueY}[/]";
                series.tensionX = 0.8;
                series.showOnInit = false;
                series.strokeWidth = 3;
                series.zIndex = 1;
                valueAxis.renderer.line.stroke = series.stroke;
                valueAxis.renderer.labels.template.fill = series.stroke;
            } else {
                const series = chart.series.push(new am4charts.ColumnSeries());
                series.dataFields.valueY = field;
                series.dataFields.dateX = "hora_local";
                series.stroke = am4core.color(color);
                series.fill = am4core.color(color);
                series.columns.template.strokeWidth = 2;
                series.columns.template.column.cornerRadiusTopLeft = 10;
                series.columns.template.column.cornerRadiusTopRight = 10;
                series.yAxis = valueAxis;
                series.name = name;
                series.tooltipText = "[bold]{valueY}[/]";
                series.tensionX = 0.8;
                series.showInit = false;
                valueAxis.renderer.line.stroke = series.stroke;
                valueAxis.renderer.labels.template.fill = series.stroke;    
            }

            if (field === "hum") {
                valueAxis.max = 100;

                if (!!buffer.hum && buffer.hum.length > 1) {
                    const rangeHum = valueAxis.axisRanges.create();
                    rangeHum.value = buffer.hum[0];
                    rangeHum.endValue = buffer.hum[1];
                    rangeHum.axisFill.fill = am4core.color("#3BC4D0");
                    rangeHum.axisFill.fillOpacity = 0.2;
                } else if (!!buffer.hum && buffer.hum.length === 1) {
                    const rangeHum = valueAxis.axisRanges.create();
                    rangeHum.value = buffer.hum[0];
                    rangeHum.endValue = buffer.hum[0] + 0.2;
                    rangeHum.axisFill.fill = am4core.color("#3BC4D0");
                    rangeHum.axisFill.fillOpacity = 0.9;
                }
            } else if (field === 'temp') {
                if (!!buffer.temp && buffer.temp.length > 1) {
                    const rangeTemp = valueAxis.axisRanges.create();
                    rangeTemp.value = buffer.temp[0];
                    rangeTemp.endValue = buffer.temp[1];
                    rangeTemp.axisFill.fill = am4core.color("#FA2A5A");
                    rangeTemp.axisFill.fillOpacity = 0.2;
                } else if (!!buffer.temp && buffer.temp.length === 1) {
                    const rangeTemp = valueAxis.axisRanges.create();
                    rangeTemp.value = buffer.temp[0];
                    rangeTemp.endValue = buffer.temp[0] + 0.2;
                    rangeTemp.axisFill.fill = am4core.color("#FA2A5A");
                    rangeTemp.axisFill.fillOpacity = 0.5;
                }
            }

            valueAxis.min = 0;
            valueAxis.renderer.line.strokeOpacity = 1;
            valueAxis.renderer.line.strokeWidth = 2;
            valueAxis.renderer.opposite = opposite;
            valueAxis.cursorTooltipEnabled = false;
            valueAxis.renderer.grid.template.disabled = true;
        }

        createAxisAndSeries("temp", "Temperatura °C", true, "#FA2A5A");
        createAxisAndSeries("hum", "Humedad Relativa %", false, "#3BC4D0");
        createAxisAndSeries("pre", "Precipitación mm", true, "#3983D9");

        chart.cursor = new am4charts.XYCursor();
        chart.cursor.behavior = "zoomX";
        chart.cursor.xAxis = dateAxis;
        chart.cursor.lineY.disabled = true;
        chart.numberFormatter.numberFormat = "##.##";

        // Crear leyenda
        chart.legend = new am4charts.Legend();

        function createTrendLine(data, color) {
            const trend = chart.series.push(new am4charts.LineSeries());
            trend.dataFields.valueY = "value";
            trend.dataFields.dateX = "date";
            trend.strokeWidth = 3;
            trend.strokeDasharray = 5;
            trend.stroke = trend.fill = am4core.color(color);
            trend.strokeOpacity = 0.5;
            trend.data = data;
            trend.hiddenInLegend = true;
            trend.showOnInit = false;

            return trend;
        }
    }

    componentWillUnmount() {
        if (this.chart) {
            this.chart.dispose();
        }
    }

    render() {
        if (this.state.visible) {
            return (
                <div id="modelo-temp-hum-pre" style={{ margin: '20px 0px' }}/>
            );
        }

        return (
            <div className="circleUPL">
                <CircularProgress color={'#db5c26'} size={186} thickness={10} value={70} />
            </div>

        )
    }
}

export class MH extends Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: false
        };
    };

    componentDidMount() {
        setTimeout(() => {
            this.loadChart();
        }, 1000);
    }

    loadChart = () => {
        this.setState({
            visible: true
        });

        const chart = am4core.create("modelo-mh", am4charts.XYChart);
        chart.zoomOutButton.disabled = true;
        chart.language.locale = am4lang_es_ES;

        const { data } = this.props;

        chart.data = data;

        chart.dateFormatter.inputDateFormat = 'yyyy-MM-ddTHH:mm:ss';

        // Create axes
        const dateAxis = chart.xAxes.push(new am4charts.DateAxis());
        dateAxis.groupData = false;
        dateAxis.renderer.grid.template.disabled = true;
        dateAxis.baseInterval = {
            "timeUnit": "hour",
            "count": 1
        };
        dateAxis.dateFormatter.dateFormat = "dd-MM-yyyy";
        dateAxis.renderer.minGridDistance = 60;
        dateAxis.dateFormats.setKey("month", "MMM");
        dateAxis.periodChangeDateFormats.setKey("month", "[bold]MMM");
        dateAxis.dateFormats.setKey("day", "MMM dd");
        dateAxis.periodChangeDateFormats.setKey("day", "[bold]MMM");
        dateAxis.dateFormats.setKey("hour", "HH:mm");
        dateAxis.periodChangeDateFormats.setKey("hour", "[bold]MMM dd[/]");
        dateAxis.dateFormats.setKey("minute", "HH:mm");
        dateAxis.periodChangeDateFormats.setKey("minute", "[bold]MM dd[/]");

        const buttonContainer = chart.plotContainer.createChild(am4core.Container);
        buttonContainer.shouldClone = false;
        buttonContainer.align = "right";
        buttonContainer.valign = "bottom";
        buttonContainer.zIndex = 100;
        buttonContainer.marginBottom = 5;
        buttonContainer.marginRight = 5;
        buttonContainer.layout = "horizontal";
    
        const zoomOutButton = buttonContainer.createChild(am4core.Button);
        zoomOutButton.label.text = "-";
        zoomOutButton.events.on("hit", () => {
            dateAxis.zoomToIndexes(dateAxis.startIndex, dateAxis.endIndex);
        });

        //Create series
        function createAxisAndSeries(field, name, opposite, color) {
            const valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
            
            const series = chart.series.push(new am4charts.StepLineSeries());
            series.dataFields.valueY = field;
            series.dataFields.dateX = "hora_local";
            series.stroke = am4core.color(color);
            series.fill = am4core.color(color);
            series.strokeWidth = 2;
            series.yAxis = valueAxis;
            series.name = name;
            series.tooltipText = "[bold]{valueY}[/]";
            series.tensionX = 0.8;
            series.showOnInit = false;

            valueAxis.min = 0;
            valueAxis.renderer.line.strokeOpacity = 1;
            valueAxis.renderer.line.strokeWidth = 2;
            valueAxis.renderer.line.stroke = series.stroke;
            valueAxis.renderer.labels.template.fill = series.stroke;
            valueAxis.renderer.opposite = opposite;
            valueAxis.cursorTooltipEnabled = false;
            valueAxis.renderer.grid.template.disabled = true;
        }

        createAxisAndSeries("mh", "Mojamiento de hoja", false, "#8DCE3E");

        chart.cursor = new am4charts.XYCursor();
        chart.cursor.behavior = "zoomX";
        chart.cursor.xAxis = dateAxis;
        chart.cursor.fullWidthLineX = true;
		chart.cursor.lineX.strokeWidth = 0;
		chart.cursor.lineX.fill = am4core.color("#000");
		chart.cursor.lineX.fillOpacity = 0.1;
        chart.cursor.lineY.disabled = true;
        chart.numberFormatter.numberFormat = "##.#";

        // Crear leyenda
        chart.legend = new am4charts.Legend();
    }

    componentWillUnmount() {
        if (this.chart) {
            this.chart.dispose();
        }
    }

    render() {
        if (this.state.visible) {
            return ( 
                <div id="modelo-mh" style={{ margin: '20px 20px 20px 0px' }}/>
            );
        }

        return (
            <div className="circleUPL">
                <CircularProgress color={'#db5c26'} size={186} thickness={10} value={70} />
            </div>
        )
    }
}

export class DPV extends Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: false
        };
    };

    componentDidMount() {
        setTimeout(() => {
            this.loadChart();
        }, 1000);
    }

    loadChart = () => {
        this.setState({
            visible: true
        });

        const chart = am4core.create("modelo-dpv", am4charts.XYChart);
        chart.zoomOutButton.disabled = true;
        chart.language.locale = am4lang_es_ES;

        const
            { data, buffer } = this.props,
            trendStart = data[0].hora_local,
            trendEnd = data[data.length - 1].hora_local
        ;

        chart.data = data;

        // Set input format for the dates
        chart.dateFormatter.inputDateFormat = 'yyyy-MM-ddTHH:mm:ss';

        // Create axes
        const dateAxis = chart.xAxes.push(new am4charts.DateAxis());
        dateAxis.groupData = false;
        dateAxis.renderer.grid.template.disabled = true;
        dateAxis.baseInterval = {
            "timeUnit": "hour",
            "count": 1
        };
        dateAxis.dateFormatter.dateFormat = "dd-MM-yyyy";
        dateAxis.renderer.minGridDistance = 60;
        dateAxis.dateFormats.setKey("month", "MMM");
        dateAxis.periodChangeDateFormats.setKey("month", "[bold]MMM");
        dateAxis.dateFormats.setKey("day", "MMM dd");
        dateAxis.periodChangeDateFormats.setKey("day", "[bold]MMM");
        dateAxis.dateFormats.setKey("hour", "HH:mm");
        dateAxis.periodChangeDateFormats.setKey("hour", "[bold]MMM dd[/]");
        dateAxis.dateFormats.setKey("minute", "HH:mm");
        dateAxis.periodChangeDateFormats.setKey("minute", "[bold]MM dd[/]");

        const buttonContainer = chart.plotContainer.createChild(am4core.Container);
        buttonContainer.shouldClone = false;
        buttonContainer.align = "right";
        buttonContainer.valign = "bottom";
        buttonContainer.zIndex = 100;
        buttonContainer.marginBottom = 5;
        buttonContainer.marginRight = 5;
        buttonContainer.layout = "horizontal";
    
        const zoomOutButton = buttonContainer.createChild(am4core.Button);
        zoomOutButton.label.text = "-";
        zoomOutButton.events.on("hit", () => {
            dateAxis.zoomToIndexes(dateAxis.startIndex, dateAxis.endIndex);
        });

        // Create series
        function createAxisAndSeries(field, name, opposite, color) {
            const valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
            
            const series = chart.series.push(new am4charts.LineSeries());
            series.dataFields.valueY = field;
            series.dataFields.dateX = "hora_local";
            series.stroke = am4core.color(color);
            series.fill = am4core.color(color);
            series.strokeWidth = 2;
            series.yAxis = valueAxis;
            series.name = name;
            series.tooltipText = "[bold]{valueY}[/]";
            series.tensionX = 0.8;
            series.showOnInit = false;

            if (!!buffer.dpv && buffer.temp.length > 1) {
                const rangeDPV = valueAxis.axisRanges.create();
                rangeDPV.value = buffer.dpv[0];
                rangeDPV.endValue = buffer.temp[1];
                rangeDPV.axisFill.fill = am4core.color("#00D5A3");
                rangeDPV.axisFill.fillOpacity = 0.2;
            } else if (!!buffer.dpv && buffer.dpv.length === 1) {
                const rangeDPV = valueAxis.axisRanges.create();
                rangeDPV.value = buffer.dpv[0];
                rangeDPV.endValue = buffer.dpv[0] + 0.2;
                rangeDPV.axisFill.fill = am4core.color("#FF1493");
                rangeDPV.axisFill.fillOpacity = 0.5;
        }

            valueAxis.min = 0;
            valueAxis.renderer.line.strokeOpacity = 1;
            valueAxis.renderer.line.strokeWidth = 2;
            valueAxis.renderer.line.stroke = series.stroke;
            valueAxis.renderer.labels.template.fill = series.stroke;
            valueAxis.renderer.opposite = opposite;
            valueAxis.cursorTooltipEnabled = false;
            valueAxis.renderer.grid.template.disabled = true;
        }

        createAxisAndSeries("dpv", "Déficir de Presión de Vapor hPa", false, "#00D5A3");

        chart.cursor = new am4charts.XYCursor();
        chart.cursor.behavior = "zoomX";
        chart.cursor.xAxis = dateAxis;
        chart.cursor.lineY.disabled = true;
        chart.numberFormatter.numberFormat = "##.#";

        // Crear leyenda
        chart.legend = new am4charts.Legend();
    }

    componentWillUnmount() {
        if (this.chart) {
            this.chart.dispose();
        }
    }

    render() {
        if (this.state.visible) {
            return ( 
                <div id="modelo-dpv" style={{ margin: '20px 0px' }}/>
            );
        }

        return (
            <div className="circleUPL">
                <CircularProgress color={'#db5c26'} size={186} thickness={10} value={70} />
            </div>
        )
    }
}
export class SigatokaRiesgo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: false
        };
    };

    componentDidMount() {
        setTimeout(() => {
            this.loadChart();
        }, 1000);
    }

    loadChart = () => {
        this.setState({
            visible: true,
        });

        const chart = am4core.create('modelo-sigatokaSemanal', am4charts.XYChart);
        chart.zoomOutButton.disabled = true;
        chart.language.locale = am4lang_es_ES;

        const { data } = this.props;

        chart.data = data;

        chart.dateFormatter.inputDateFormat = 'yyyy-MMM-dd HH:mm';

        const dateAxis = chart.xAxes.push(new am4charts.DateAxis());
        // dateAxis.groupData = true;
        dateAxis.renderer.grid.template.disabled = true;
        dateAxis.baseInterval = {
            "timeUnit": "hour",
            "count": 1
        };
        dateAxis.dateFormatter.dateFormat = 'dd-MMM-yyyy HH:mm';
        dateAxis.renderer.minGridDistance = 60;
        // dateAxis.dateFormats.setKey("month", "MMM");
        // dateAxis.periodChangeDateFormats.setKey("month", "[bold]MMM");
        // dateAxis.dateFormats.setKey("hour", "HH:mm");
        // dateAxis.periodChangeDateFormats.setKey("hour", "[bold]MMM dd[/]");

        const buttonContainer = chart.plotContainer.createChild(am4core.Container);
        buttonContainer.shouldClone = false;
        buttonContainer.align = "right";
        buttonContainer.valign = "top";
        buttonContainer.zIndex = 100;
        buttonContainer.marginTop = -15;
        buttonContainer.marginRight = 5;
        buttonContainer.layout = "horizontal";

        const zoomOutButton = buttonContainer.createChild(am4core.Button);
        zoomOutButton.label.text = "-";
        zoomOutButton.events.on("hit", () => {
            dateAxis.zoomToIndexes(dateAxis.startIndex, dateAxis.endIndex);
        });

        function createAxisAndSeries(field, name, opposite, color) {
            const valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
            if (chart.yAxes.indexOf(valueAxis) !== 0 ) {
                valueAxis.syncWithAxis = chart.yAxes.getIndex(0);
            }

            if (field !== 'pre') {
                const series = chart.series.push(new am4charts.LineSeries());
                series.dataFields.valueY = field;
                series.dataFields.dateX = "fecha";
                series.stroke = am4core.color(color);
                series.fill = am4core.color(color);
                series.yAxis = valueAxis;
                series.name = name;
                series.tooltipText = "[bold]{valueY}[/]";
                series.tensionX = 0.8;
                series.showOnInit = false;
                series.strokeWidth = 2;
                // series.zIndex = 1;
                valueAxis.renderer.line.stroke = series.stroke;
                valueAxis.renderer.labels.template.fill = series.stroke;
            } else {
                const series = chart.series.push(new am4charts.ColumnSeries());
                series.dataFields.valueY = field;
                series.dataFields.dateX = "fecha";
                series.stroke = am4core.color(color);
                series.fill = am4core.color(color);
                series.columns.template.strokeWidth = 2;
                series.columns.template.column.cornerRadiusTopLeft = 10;
                series.columns.template.column.cornerRadiusTopRight = 10;
                series.yAxis = valueAxis;
                series.name = name;
                series.tooltipText = "[bold]{valueY}[/]";
                series.tensionX = 0.8;
                series.showInit = false;
                valueAxis.renderer.line.stroke = series.stroke;
                valueAxis.renderer.labels.template.fill = series.stroke;    
            }

            if (field === 'riesgo') {
                valueAxis.max = 100;
            }

            valueAxis.min = 0;
            valueAxis.renderer.line.strokeOpacity = 1;
            valueAxis.renderer.line.strokeWidth = 2;
            valueAxis.renderer.opposite = opposite;
            valueAxis.cursorTooltipEnabled = false;
            valueAxis.renderer.grid.template.disabled = true;
        }

        createAxisAndSeries("pre", "Precipitación mm", false, "#3983D9");
        createAxisAndSeries("riesgo", "Riesgo de Infeccion %", true, "#F40E00");

        chart.cursor = new am4charts.XYCursor();
        chart.cursor.behavior = "zoomX";
        chart.cursor.xAxis = dateAxis;
        chart.cursor.lineY.disabled = true;
        chart.numberFormatter.numerFormat = "##.#";

        chart.legend = new am4charts.Legend();
    }

    componentWillUnmount() {
        if (this.chart) {
            this.chart.dispose();
        }
    }

    render() {
        if (this.state.visible) {
            return (
                <div id="modelo-sigatokaSemanal" style={{ margin: '20px 0px' }}/>
            );
        }

        return (
            <div className="circleUPL" style={{ marginTop: '100px '}}>
                <CircularProgress color={'#db5c26'} size={186} thickness={10} value={70} />
            </div>

        )
    }
}



// WEBPACK FOOTER //
// ./src/ModeloGraph.js